import moment from 'moment';
import React  from 'react';

export default ({ dateTime, value }: { dateTime?: boolean, value: string | Moment | Date }) => {
	return (
		<span>
			{moment(value).format(dateTime ? 'L LT' : 'L')}
		</span>
	);
};